import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authApi } from "../../services/authApi";
import { formatApiErrorDetail } from "../../lib/api";
import { useLocalization } from "../../hooks/useLocalization";

export default function ForgotPasswordPage() {
  const { t } = useLocalization();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await authApi.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  return (
    <div className="w-full max-w-sm" data-testid="forgot-password-page">
      <h2 className="text-2xl font-bold tracking-tight text-gray-900 mb-6">{t("auth.resetPassword")}</h2>
      {sent ? (
        <p className="text-sm text-emerald-600" data-testid="reset-link-sent-message">
          {t("auth.resetLinkSentMessage")}
        </p>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <label htmlFor="forgot-password-email" className="sr-only">{t("auth.email")}</label>
          <input
            id="forgot-password-email"
            data-testid="forgot-password-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("auth.email")}
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
          />
          {error && <p className="text-sm text-red-500">{error}</p>}
          <button
            data-testid="forgot-password-submit-button"
            type="submit"
            className="w-full py-3 rounded-full bg-blue-600 text-white font-semibold hover:bg-blue-700 active:scale-95 transition-all"
          >
            {t("auth.sendResetLink")}
          </button>
        </form>
      )}
      <Link to="/staff/login" className="text-xs font-medium text-blue-600 hover:underline block mt-4">{t("auth.backToLogin")}</Link>
    </div>
  );
}
